import { useEffect, useState } from 'react';

import { supabase } from '../auth/supabase-client';
import { compterCartesPourMoi } from '../data/decisions';
import { useEspace } from '../data/espace-context';

/**
 * Nombre de cartes qui attendent la personne connectée dans l'espace courant,
 * recompté à chaque changement de tâche de l'espace (temps réel).
 */
export function useCompteurDecisions(): number {
  const { espaceCourant, monMembre } = useEspace();
  const espaceId = espaceCourant?.id ?? null;
  const monMembreId = monMembre?.id ?? null;
  const [compteur, setCompteur] = useState(0);

  useEffect(() => {
    const client = supabase;
    if (!espaceId || !monMembreId || !client) {
      setCompteur(0);
      return;
    }
    let actif = true;
    let minuterie: number | null = null;
    const recompter = () => {
      compterCartesPourMoi(espaceId, monMembreId)
        .then((n) => {
          if (actif) setCompteur(n);
        })
        .catch(() => {});
    };
    recompter();
    const canal = client
      .channel(`compteur-decisions:${espaceId}:${monMembreId}`)
      .on(
        'postgres_changes',
        { event: '*', schema: 'alba', table: 'tasks', filter: `workspace_id=eq.${espaceId}` },
        () => {
          // Plusieurs changements rapprochés (une décision en cascade) ne
          // déclenchent qu'un seul recomptage.
          if (minuterie) window.clearTimeout(minuterie);
          minuterie = window.setTimeout(recompter, 300);
        },
      )
      .subscribe();
    return () => {
      actif = false;
      if (minuterie) window.clearTimeout(minuterie);
      void client.removeChannel(canal);
    };
  }, [espaceId, monMembreId]);

  return compteur;
}
